import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface User {
  id: string;
  name?: string;
  email: string;
  role: string;
  enterpriseId?: string | null;
  loginMethodCode?: string | null;
  roleCode?: string;
  state?: string | null;
}

interface UserState {
  currentUser: User | null;
  loading: boolean;
}

const initialState: UserState = {
  currentUser: null,
  loading: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload;
      state.loading = false;
    },
    clearUser: (state) => {
      state.currentUser = null;
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const getUser = (state: { user: UserState }) => state.user.currentUser;
export const { setUser, clearUser, setLoading } = userSlice.actions;
export default userSlice.reducer;
